import { createRoute, getPathForAllPortals } from "utilities/flatRoutes/routes";

export const preliminaryEstimatePath = "/PreliminaryEstimate";
export const preliminaryEstimateRoute = createRoute(
    getPathForAllPortals(preliminaryEstimatePath),
    "Preliminary Estimates",
);

export const preliminaryEstimateGeneratePath = "/PreliminaryEstimate/Generate";
export const preliminaryEstimateGenerateRoute = createRoute(
    getPathForAllPortals(preliminaryEstimateGeneratePath),
    "Preliminary Estimate",
);

interface IPreliminaryEstimateDetailParams {
    /** The estimate's externalID — stable across stores, unlike the identity key. */
    id: string;
}

// The page behind this route is #281500 and is not registered yet, so following the link 404s
// until that ships. The list links to it now so row navigation lands with that ticket, not after.
export const preliminaryEstimateDetailPath = "/PreliminaryEstimate/:id";
export const preliminaryEstimateDetailRoute = createRoute<IPreliminaryEstimateDetailParams>(
    getPathForAllPortals(preliminaryEstimateDetailPath),
    "Preliminary Estimate",
);
